import { Route } from "@angular/router";
import { ParceirosPage } from "./parceiros.page";

export const ParceirosRouter: Route[] = [
  { path: 'parceiros', component: ParceirosPage }
];
